import { PORTCO_CLOSE_MANAGE_COLUMN } from "../actions";

export default () => {
  return dispatch => {
    dispatch({
      type: PORTCO_CLOSE_MANAGE_COLUMN
    });
  };
};